import React from 'react';
import { STEP_IDS } from '../types/lectureForm.types';

// Import step components
import InformationStep from '../steps/InformationStep';
import GeneralConditionsStep from '../steps/GeneralConditionsStep';
import LectureTypeStep from '../steps/LectureTypeStep';
import ConditionsStep from '../steps/ConditionsStep';
import SpeakersStep from '../steps/SpeakersStep';
import LanguageStep from '../steps/LanguageStep';
import TitleStep from '../steps/TitleStep';
import DescriptionStep from '../steps/DescriptionStep';
import SubjectsStep from '../steps/SubjectsStep';
import TopicsStep from '../steps/TopicsStep';
import ImageStep from '../steps/ImageStep';
import HandoutStep from '../steps/HandoutStep';
import PresentationStep from '../steps/PresentationStep';
import ReviewStep from '../steps/ReviewStep';
import CommunicateStep from '../steps/CommunicateStep';

// Step component mapping
const STEP_COMPONENTS = {
  [STEP_IDS.INFORMATION]: InformationStep,
  [STEP_IDS.LECTURE_TYPE]: LectureTypeStep,
  [STEP_IDS.GENERAL_CONDITIONS]: GeneralConditionsStep,
  [STEP_IDS.TITLE]: TitleStep,
  [STEP_IDS.LANGUAGE]: LanguageStep,
  [STEP_IDS.TOPICS]: TopicsStep,
  [STEP_IDS.SPEAKERS]: SpeakersStep,
  [STEP_IDS.DESCRIPTION]: DescriptionStep,
  [STEP_IDS.SUBJECTS]: SubjectsStep,
  [STEP_IDS.IMAGE]: ImageStep,
  [STEP_IDS.HANDOUT]: HandoutStep,
  [STEP_IDS.PRESENTATION]: PresentationStep,
  [STEP_IDS.MARKETING]: CommunicateStep, // Rename communicate to marketing
  [STEP_IDS.REVIEW]: ReviewStep
};

export default function StepRenderer({ activeStep, onStepComplete, onStepChange, companyId, eventId, lectureId, onSaveLecture, isSavingLecture }) {
  const StepComponent = STEP_COMPONENTS[activeStep];

  // Fallback if step component not found
  if (!StepComponent) {
    return (
      <div className="text-center p-4">
        <h5>Schritt wird geladen...</h5>
        <p>Schritt "{activeStep}" ist noch nicht implementiert.</p>
      </div>
    );
  }

  return (
    <div className="step-content d-flex flex-column h-100">
      <StepComponent 
        onComplete={onStepComplete}
        onStepChange={onStepChange}
        stepId={activeStep}
        companyId={companyId}
        eventId={eventId}
        lectureId={lectureId}
        onSaveLecture={onSaveLecture}
        isSavingLecture={isSavingLecture}
      />
    </div>
  );
}